import { render } from "./GoalSettings.vue?vue&type=template&id=2ec572ac"
import script from "./GoalSettings.vue?vue&type=script&lang=js"
export * from "./GoalSettings.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__